import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

type Entity = models.MatrizTarifaGlobales;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
}

/**
* Componente para editar un Entity
*/
export class TarifaGlobalesComponent extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {};
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Number = getField(kea.Number);

        return (
            <div>
                <h3>Seguro</h3>
                {kea.autogrid(6, [<Number field="FactorSeguro" label="Porcentaje del valor declarado" format="percentage" />])}
                <hr />

                <h3>Acuses</h3>
                {kea.autogrid(6, [
                    <Number field="ImporteAcuseInterno" label="Acuse interno" format="currency" />,
                    <Number field="ImporteAcuseExterno" label="Acuse externo" format="currency" />,
                ])}
                <hr />

                <h3>Entrega a domicilio</h3>

                {kea.autogrid(6, [
                    <Number field="FactorFleteEntregaDomicilio" label="Porcentaje del flete" format="percentage" />,
                    <Number field="MinimoEntregaDomicilio" label="Tarifa mínima" format="currency" />,
                ])}


                <h3>Recolección a domicilio</h3>
                {kea.autogrid(6, [

                    <Number field="FactorFleteRecoleccionDomicilio" label="Porcentaje del flete" format="percentage" />,
                    <Number field="MinimoRecoleccionDomicilio" label="Tarifa mínima" format="currency" />,
                ])}

                <h3>Valor de factura</h3>
                {kea.autogrid(6, [
                    <Number field="PorcentajeValorFactura" label="Porcentaje del valor de factura" format="percentage" />,
                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/edit/componentes/globales.tsx